import { motion } from 'framer-motion';
import { Gamepad2, Music, Drama, Palette, Clapperboard } from 'lucide-react';

const cards = [
    {
        id: 'gamer',
        icon: Gamepad2,
        title: 'Gamer raiz',
        text: 'Resident Evil, Life is Strange, The Forest, Dead Island, Guitar Hero — FPS, sandbox e clássicos de PS2/Nintendo.'
    },
    {
        id: 'rock',
        icon: Music,
        title: 'Avenged Sevenfold fan',
        text: 'Eclética no fone. Já fui em Knotfest e I Wanna Be Tour 🎸'
    },
    {
        id: 'violin',
        icon: Drama,
        title: 'Toco violino',
        text: 'Desde criança. Música é casa.'
    },
    {
        id: 'cosplay',
        icon: Palette,
        title: 'Cosplayer & Cosmaker',
        text: 'Maquiagem artística, artesanato e cosplays nas horas livres.'
    },
    {
        id: 'movies',
        icon: Clapperboard,
        title: 'Black Mirror, terror & Marvel/DC',
        text: 'Fim de semana é cinema, série e um vinho 🍷'
    }
];

export const AboutSection = () => {
    return (
        <section
            data-testid="about-section"
            className="px-5 pt-10"
        >
            <motion.h2
                initial={{ opacity: 0, y: 8 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5 }}
                className="font-heading text-rose-200 text-xs uppercase tracking-[0.25em] mb-4 text-center"
            >
                ⋅ Sobre a Kell ⋅
            </motion.h2>

            <div className="space-y-3">
                {cards.map((card, i) => {
                    const Icon = card.icon;
                    return (
                        <motion.div
                            key={card.id}
                            data-testid={`about-card-${card.id}`}
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ delay: i * 0.06, duration: 0.45, ease: 'easeOut' }}
                            className="glass border border-rose-200/10 rounded-2xl p-4 flex items-start gap-3"
                        >
                            <div className="w-10 h-10 rounded-xl bg-rose-300/10 flex items-center justify-center shrink-0">
                                <Icon className="w-5 h-5 text-[#d62828]" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <h3 className="text-rose-50 font-semibold text-[0.95rem] mb-0.5">
                                    {card.title}
                                </h3>
                                <p className="text-rose-100/65 text-sm leading-relaxed">
                                    {card.text}
                                </p>
                            </div>
                        </motion.div>
                    );
                })}
            </div>
        </section>
    );
};

export default AboutSection;
